export const medusaPriceAmountToMoney = (amount: number, maximumFractionDigits = 2) => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits
  });

  return formatter.format(amount / 100);
};
